<template>
  <div class="google-map-recommend">
    <div class="address" v-if="tempData">
      {{ tempData.location.address.detail }}
    </div>
    <google-map
      v-model="tempData.location"
      :inputBox="1"
      map-id="editGoogle"
    ></google-map>
    <div class="button-box">
      <base-button-type-1 typeColor="white" @click="cancel" text="CANCEL" />
      <base-button-type-1 text="OK" @click="confirm" />
    </div>
  </div>
</template>

<script>
import GoogleMap from './GoogleMap'
import { mapGetters } from 'vuex'
import BaseButtonType1 from './form-elemnets/BaseButtonType1'
import { updateRequestReservation } from '../../api/reservation'
import * as types from '../../store/mutation-types'

export default {
  name: 'google-map-recommend',
  components: { BaseButtonType1, GoogleMap },
  data() {
    return {
      tempData: ''
    }
  },
  mounted() {
    this.tempData = { ...this.modalGoogleMapComponentPropData }
    console.log(this.tempData)
  },
  methods: {
    confirm() {
      updateRequestReservation(this.tempData.id, this.tempData).then(() => {
        this.$router.push({ path: '/user/booking' })
        this.$store.dispatch(types.SET_MODAL_COMPONENT, {
          component: '',
          active: false,
          type: 'full'
        })
      })
    },
    cancel() {
      this.$router.push('/user/booking')
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: '',
        active: false,
        type: 'full'
      })
    }
  },
  computed: {
    ...mapGetters(['modalGoogleMapComponentPropData'])
  }
}
</script>

<style lang="scss" scoped>
.google-map-recommend {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column nowrap;

  .address {
    margin: 10px;
  }

  .google-map {
    /*border: 1px solid red;*/
    height: 400px;
    width: 90%;
  }

  .button-box {
    display: flex;
    align-self: flex-end;
    margin: 20px 34px 0 0;

    .base-button-type-1 {
      &:not(:last-child) {
        margin: 0 20px 0 0;
      }
    }
  }
}
</style>
